import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { CharcoalProvider } from "@charcoal-ui/react";
import "@charcoal-ui/icons";
import { App } from "./App";
import "./styles.css";

const root = document.getElementById("root");
if (root === null) {
  throw new Error("root element is missing");
}

createRoot(root).render(
  <StrictMode>
    <CharcoalProvider>
      <App />
    </CharcoalProvider>
  </StrictMode>,
);
